import { forwardRef } from 'react';

import ChainIcon from '@/components/ChainIcon';
import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';
import { truncateMidAddressInputValue } from '@/utils/truncateAddress';

import { useCoinwebWallet } from '../../../hooks';

export const ConnectedCoinwebWalletButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, ...props }, ref) => {
    const { address } = useCoinwebWallet();
    const truncatedAddress = truncateMidAddressInputValue(address || '');

    return (
      <Button
        ref={ref}
        size="sm"
        variant="secondary"
        className={cn('font-roboto rounded-xl font-bold', className)}
        {...props}
      >
        {children || (
          <div className="flex items-center gap-1 text-sm sm:gap-2">
            <ChainIcon src="/chains/coinweb.svg" />
            <div className="hidden sm:block">{truncatedAddress}</div>
          </div>
        )}
      </Button>
    );
  }
);

ConnectedCoinwebWalletButton.displayName = 'CoinwebWalletButton';
